module.exports = __webpack_public_path__ + "img/icon-universidade.c75e5d4c.svg";